import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { Container, Col, Row } from 'reactstrap';
import * as wasteReadingActions from '../../../actions/wasteReadingActions';
import { isEmpty } from '../../../utils/objectChecker';
import { toast } from 'react-toastify';
import WasteReadingAdminForm from './WasteReadingAdminForm';

class ManageWasteReadingPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentReading: props.currentReading || {},
      errors: {},
      saving: false,
      selectedSystemState: 'MO',
      selectedWeatherType: {},
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.currentReading) {
      if (this.props.currentReading.id !== nextProps.currentReading.id) {
        this.setState({
          currentReading: Object.assign({}, nextProps.currentReading),
        });
      }
    }
  }

  redirectSuccess(msg) {
    this.setState({ saving: false });
    toast.success(msg);
    this.props.history.push('/wastewater');
  }

  formIsValid() {
    const { wasteReading } = this.state;
    let errors = {};
    let isValid = true;

    if (wasteReading.weather === '') {
      errors.weather = 'Please select the weather type.';
      isValid = false;
    }
    if (isEmpty(wasteReading.weather)) {
      errors.weather = 'Please select the weather type.';
      isValid = false;
    }
    this.setState({ errors: errors });
    return isValid;
  }

  saveReading = (reading) => {
    this.props.actions
      .saveWasteReading(reading)
      .then(() => this.redirectSuccess('Reading saved'))
      .catch((error) => {
        toast.error(error);
      });
  };

  deleteReading = (reading) => {
    this.props.actions
      .deleteWasteReading(reading)
      .then(() => this.redirectSuccess('Reading deleted'))
      .catch((error) => {
        toast.error(error);
      });
  };

  render() {
    const { currentReading } = this.props;
    const { selectedWeatherType, selectedSystemState, saving } = this.state;
    return (
      <div>
        <Container fluid={true}>
          <Row>
            <Col md={12} className="text-center">
              <h1 className="my-4">Manage Wastewater Reading</h1>
            </Col>
          </Row>

          <Row>
            <Col md={3} />
            <Col md={6} className="mb-4">
              <WasteReadingAdminForm
                reading={currentReading}
                onSave={this.saveReading}
                onDelete={this.deleteReading}
              />
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

ManageWasteReadingPage.propTypes = {
  currentReading: PropTypes.object,
  actions: PropTypes.object,
};

function getReadingById(readings, id) {
  const reading = readings.filter((r) => r.id === id);
  if (reading) return reading[0];
  return null;
}

function mapStateToProps(state, ownProps) {
  const id = ownProps.match.params.id;
  const readingId = Number.parseInt(id, 10);

  let currentReading = {
    siteId: '',
    timestamp: '',
    masterReading: '',
    phIn: '',
    tempIn: '',
    phOut: '',
    bioOxyDemand: '',
    chlorineResidual: '',
    phosphorous: '',
    dissolvedOxygen: '',
    dechlorination: '',
    sludgeLevel: '',
    tempOut: '',
    precipitation: '',
    weather: '',
    comments: '',
    userId: '',
  };

  if (readingId && state.wasteReadings.length > 0) {
    currentReading = getReadingById(state.wasteReadings, readingId);
  }

  return {
    currentReading: currentReading,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(wasteReadingActions, dispatch),
  };
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ManageWasteReadingPage)
);



// WEBPACK FOOTER //
// ./src/components/reading/waste/ManageWasteReadingPage.js